import React, { ComponentPropsWithoutRef, forwardRef } from 'react';
import styles from "./NJChatExchange.module.css";

/**
 * Interface for chat exchange properties.
 *
 * @interface IChatExchangeProps
 */
export interface IChatExchangeProps extends ComponentPropsWithoutRef<'div'> {
  children: React.ReactElement | React.ReactElement[];
}

export const NJChatExchange = forwardRef<HTMLDivElement, IChatExchangeProps>(
  ({ children, ...props }, ref) => {

    return (
      <div ref={ref} {...props}  className={`
      ${styles["nj-chat-exchange"]}
        ${props.className} 
        `}
      >
        {children}
      </div>
    );
  }
);
